import React, { useEffect, useState } from "react";
import "./FeaturedSales.css";
import { FaBed, FaBath } from "react-icons/fa";
import { MdSquareFoot } from "react-icons/md";
import Bedroom from "../Images/Bedroom.jpg";
import { useNavigate } from "react-router-dom";
import { CreateOrder, getGalleries, getProperties, VerifyPayment } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { toast } from "sonner";



/* ── Inline SVG Icons ── */
const IconBed = () => (
  <svg viewBox="0 0 24 24" style={{width:14,height:14,stroke:"currentColor",fill:"none",strokeWidth:1.8,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <path d="M2 9V19M22 9V19M2 14H22M2 9C2 9 4 7 12 7C20 7 22 9 22 9"/><rect x="6" y="11" width="4" height="3" rx="1"/><rect x="14" y="11" width="4" height="3" rx="1"/>
  </svg>
);
const IconBath = () => (
  <svg viewBox="0 0 24 24" style={{width:14,height:14,stroke:"currentColor",fill:"none",strokeWidth:1.8,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <path d="M4 12H20V14C20 17.314 17.314 20 14 20H10C6.686 20 4 17.314 4 14V12Z"/><path d="M7 12V6C7 4.343 8.343 3 10 3H11C12.657 3 14 4.343 14 6V12"/><path d="M4 17.5L3 20M20 17.5L21 20"/>
  </svg>
);
const IconSize = () => (
  <svg viewBox="0 0 24 24" style={{width:14,height:14,stroke:"currentColor",fill:"none",strokeWidth:1.8,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M3 9h6M3 15h6"/>
  </svg>
);
const IconLocation = () => (
  <svg viewBox="0 0 24 24" style={{width:12,height:12,stroke:"currentColor",fill:"none",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" style={{width:11,height:11,stroke:"currentColor",fill:"none",strokeWidth:2,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>
  </svg>
);
const IconArrow = () => (
  <svg viewBox="0 0 24 24" style={{width:14,height:14,stroke:"currentColor",fill:"none",strokeWidth:2.2,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <path d="M5 12h14M13 6l6 6-6 6"/>
  </svg>
);
const IconShield = () => (
  <svg viewBox="0 0 24 24" style={{width:12,height:12,stroke:"currentColor",fill:"none",strokeWidth:1.8,strokeLinecap:"round",strokeLinejoin:"round"}}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" style={{width:11,height:11,fill:"var(--gold)",stroke:"none"}}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Jost:wght@300;400;500;600&display=swap');

:root {
  --gold: #C9962A;
  --gold-light: #E8C06A;
  --gold-pale: #FBF3E0;
  --gold-glow: rgba(201,150,42,0.16);
  --brown-dark: #2C1A0E;
  --brown-mid: #4A2E1A;
  --brown-soft: #7A5230;
  --off-white: #FDFAF5;
  --cream: #F5EDD8;
  --text-muted: #9A7B5A;
  --border: rgba(201,150,42,0.22);
  --card-shadow: 0 4px 24px rgba(44,26,14,0.08), 0 1px 6px rgba(44,26,14,0.05);
  --card-shadow-hover: 0 16px 48px rgba(44,26,14,0.14), 0 4px 16px rgba(44,26,14,0.08);
}

/* ── Container ── */
.featured-sales-container {
  width: 100%;
  padding: 48px 60px;
  background:
    radial-gradient(ellipse at 10% 0%, rgba(201,150,42,0.07) 0%, transparent 45%),
    radial-gradient(ellipse at 90% 100%, rgba(44,26,14,0.05) 0%, transparent 45%),
    var(--off-white);
  font-family: 'Jost', sans-serif;
  max-width: 1275px;
  margin: 0 auto;
}

/* ── Header ── */
.featured-sales-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 32px;
  animation: fs-fade-down 0.55s ease both;
}

@keyframes fs-fade-down {
  from { opacity:0; transform:translateY(-10px); }
  to   { opacity:1; transform:translateY(0); }
}

.featured-sales-header-left {}

.featured-sales-header h2 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 2rem;
  font-weight: 700;
  color: var(--brown-dark);
  letter-spacing: 0.01em;
  line-height: 1.1;
  margin: 0 0 4px;
}

.fs-header-sub {
  font-size: 0.72rem;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.fs-gold-bar {
  width: 36px; height: 2px;
  background: linear-gradient(90deg, var(--gold), var(--gold-light));
  border-radius: 2px;
  margin-top: 8px;
}

/* All button */
.featured-filter-btn {
  display: flex; align-items: center; gap: 7px;
  padding: 10px 22px;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  background: rgba(251,243,224,0.55);
  font-family: 'Jost', sans-serif;
  font-size: 0.78rem; font-weight: 600;
  letter-spacing: 0.09em; text-transform: uppercase;
  color: var(--brown-soft);
  cursor: pointer;
  position: relative; overflow: hidden;
  transition: all 0.25s;
}
.featured-filter-btn::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(135deg, var(--gold-light) 0%, var(--gold) 50%, #A87820 100%);
  background-size: 200% 100%;
  background-position: 100% 0;
  opacity: 0;
  transition: opacity 0.3s, background-position 0.4s;
  border-radius: inherit;
}
.featured-filter-btn:hover::before { opacity:1; background-position:0 0; }
.featured-filter-btn:hover {
  border-color: var(--gold);
  color: var(--brown-dark);
  box-shadow: 0 4px 18px rgba(201,150,42,0.32);
  transform: translateY(-1px);
}
.featured-filter-btn:active { transform: scale(0.98); }
.featured-filter-btn span, .featured-filter-btn svg { position:relative; z-index:1; }
.featured-filter-btn svg { transition: transform 0.3s; }
.featured-filter-btn:hover svg { transform: translateX(3px); }

/* ── Grid ── */
.featured-sales-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 22px;
}

/* ── Card ── */
.featured-card {
  background:
    radial-gradient(ellipse at 0% 0%, rgba(232,192,106,0.13) 0%, transparent 55%),
    #FEFCF7;
  border: 1px solid var(--border);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: var(--card-shadow);
  transition: transform 0.28s cubic-bezier(0.22,1,0.36,1), box-shadow 0.28s;
  cursor: pointer;
  animation: card-in 0.5s ease both;
  position: relative;
}

/* stagger each card */
.featured-card:nth-child(1) { animation-delay: 0.05s; }
.featured-card:nth-child(2) { animation-delay: 0.12s; }
.featured-card:nth-child(3) { animation-delay: 0.19s; }
.featured-card:nth-child(4) { animation-delay: 0.26s; }
.featured-card:nth-child(5) { animation-delay: 0.33s; }
.featured-card:nth-child(6) { animation-delay: 0.40s; }
.featured-card:nth-child(7) { animation-delay: 0.47s; }
.featured-card:nth-child(8) { animation-delay: 0.54s; }

@keyframes card-in {
  from { opacity:0; transform: translateY(22px) scale(0.97); }
  to   { opacity:1; transform: translateY(0) scale(1); }
}

/* shimmer top bar on card */
.featured-card::before {
  content: '';
  position: absolute; top:0; left:0; right:0; height:3px;
  background: linear-gradient(90deg, transparent, var(--gold), var(--gold-light), var(--gold), transparent);
  background-size: 200% 100%;
  opacity: 0;
  animation: shimmer-line 3s linear infinite;
  transition: opacity 0.3s;
  z-index: 2;
}
.featured-card:hover::before { opacity: 1; }

@keyframes shimmer-line {
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
}

.featured-card:hover {
  transform: translateY(-6px) scale(1.01);
  box-shadow: var(--card-shadow-hover);
}

/* ── Image ── */
.featured-image-wrap {
  position: relative;
  overflow: hidden;
  height: 190px;
}
.featured-image {
  width: 100%; height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.55s cubic-bezier(0.22,1,0.36,1);
}
.featured-card:hover .featured-image {
  transform: scale(1.07);
}

/* Status badge */
.fs-badge {
  position: absolute; top: 12px; left: 12px;
  padding: 3px 11px;
  border-radius: 20px;
  font-size: 0.6rem; font-weight: 600;
  letter-spacing: 0.08em; text-transform: uppercase;
  backdrop-filter: blur(6px);
  z-index: 2;
}
.fs-badge-available {
  background: rgba(76,175,122,0.85);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.25);
}
.fs-badge-rented {
  background: rgba(201,150,42,0.88);
  color: var(--brown-dark);
  border: 1px solid rgba(255,255,255,0.2);
}

/* Type tag */
.fs-type-tag {
  position: absolute; bottom: 12px; right: 12px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 0.6rem; font-weight: 600;
  letter-spacing: 0.07em; text-transform: uppercase;
  background: rgba(44,26,14,0.72);
  color: var(--gold-light);
  border: 1px solid rgba(201,150,42,0.3);
  backdrop-filter: blur(4px);
  z-index: 2;
}

/* Rating row */
.fs-rating {
  position: absolute; top: 12px; right: 12px;
  display: flex; align-items: center; gap: 3px;
  background: rgba(254,252,247,0.88);
  padding: 3px 8px; border-radius: 20px;
  font-size: 0.65rem; font-weight: 600;
  color: var(--brown-mid);
  backdrop-filter: blur(4px);
  z-index: 2;
}

/* ── Card body ── */
.featured-card-body {
  padding: 16px 18px 18px;
}

.featured-price {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--brown-dark);
  margin-bottom: 2px;
  line-height: 1.2;
  cursor: pointer;
  transition: color 0.2s;
}
.featured-card:hover .featured-price { color: var(--brown-mid); }

/* Rent row */
.fs-rent-row {
  display: flex; align-items: baseline; gap: 6px;
  margin-bottom: 10px; flex-wrap: wrap;
}
.fs-rent-amount {
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.35rem; font-weight: 700;
  color: var(--gold);
  letter-spacing: 0.01em;
}
.fs-rent-label {
  font-size: 0.65rem; font-weight: 500;
  color: var(--text-muted); letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* Deposit row */
.fs-deposit-row {
  display: flex; align-items: center; gap: 5px;
  margin-bottom: 10px;
  font-size: 0.72rem; color: var(--text-muted);
}
.fs-deposit-row svg { flex-shrink:0; }
.fs-deposit-row span { color: var(--brown-soft); font-weight:500; }

/* Divider */
.fs-divider {
  height: 1px;
  background: var(--border);
  margin: 10px 0;
}

.featured-location {
  display: flex; align-items: center; gap: 5px;
  font-size: 0.73rem;
  color: var(--text-muted);
  margin-bottom: 4px;
}
.featured-location svg { flex-shrink:0; color:var(--gold); stroke:var(--gold); }

.featured-date {
  display: flex; align-items: center; gap: 5px;
  font-size: 0.67rem;
  color: var(--text-muted);
  margin-bottom: 12px;
  letter-spacing: 0.03em;
}
.featured-date svg { flex-shrink:0; }

/* ── Icon row ── */
.featured-icons {
  display: flex;
  gap: 0;
  font-size: 0.73rem;
  color: var(--brown-soft);
  background: var(--gold-pale);
  border: 1px solid rgba(201,150,42,0.18);
  border-radius: 10px;
  overflow: hidden;
}
.featured-icons span {
  display: flex; align-items: center; gap: 5px;
  padding: 7px 0;
  flex: 1;
  justify-content: center;
  font-weight: 500;
  border-right: 1px solid rgba(201,150,42,0.18);
  transition: background 0.2s, color 0.2s;
}
.featured-icons span:last-child { border-right: none; }
.featured-icons span:hover {
  background: rgba(201,150,42,0.12);
  color: var(--brown-dark);
}

/* ── Responsive ── */
@media (max-width:1200px) {
  .featured-sales-grid { grid-template-columns:repeat(3,1fr); }
}
@media (max-width:992px) {
  .featured-sales-container { padding:30px 30px; }
  .featured-sales-grid { grid-template-columns:repeat(2,1fr); }
}
@media (max-width:600px) {
  .featured-sales-container { padding:24px 16px; }
  .featured-sales-header { flex-direction:column; align-items:flex-start; gap:14px; }
  .featured-sales-grid { grid-template-columns:1fr; gap:18px; }
  .featured-image-wrap { height:220px; }
  .featured-sales-header h2 { font-size:1.7rem; }
}
`;

const fmtRent = (v) => "₹" + Number(v).toLocaleString("en-IN");
const fmtDate = (s) => {
  try { return new Date(s).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"}); }
  catch { return s; }
};

const FeaturedSales = () => {
  // const properties = [
  //   { id: 1, img: Bedroom },
  //   { id: 2, img: Bedroom },
  //   { id: 3, img:Bedroom },
  //   { id: 4, img: Bedroom }
  // ];

  const[properties,setProperties]=useState([])
  const navigate = useNavigate();
  const { isAuthenticated,token} = useSelector((state) => state.auth);

  const handleGetProperties=async()=>{
   try {
    const res=await getProperties()
    console.log('getProperties',res);
    if(res.status===200){
      setProperties(res.data.data)
    }
    
   } catch (error) {
    console.log(error);
    
   }
  }

    const handleGetGalleries=async()=>{
   try {
    const res=await getGalleries()
    console.log('getGalleries',res);
    
   } catch (error) {
    console.log(error);
    
   }
  }

  useEffect(() => {
    handleGetProperties()
    handleGetGalleries()
  }, [])


  const handleCreateOrder=async(id)=>{
    try {
     let data={
      property_id:id
      }
      console.log(token);
      
      const res=await CreateOrder(data,token)
      console.log(res);
      if(res.status===200){
        toast.success("Order booked")
        handlePayment(res.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }


        const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const verifyPayment=async(data)=>{
try {
  if(!token){
     toast.warning("Unauthorized login first")
        navigate("/login")
  }
  console.log(data);
  const res= await VerifyPayment(data,token)
  console.log(res);
  if(res.status===200){
    toast.success(
"Payment successful & property booked")
  }
  
  
} catch (error) {
  console.log(error);
  
}
}


  const handlePayment = async (data) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load");
      return;
    }

    // Call your backend to create order
    // const data = await fetch("/api/create-order", {
    //   method: "POST",
    // }).then((t) => t.json());

    const options = {
      key: data.key, // from Razorpay dashboard
      amount: data.amount,
      currency: "INR",
      name: "Siance Software",
      description: "Test Transaction",
      order_id: data.order_id,

      handler: function (response) {
        console.log("Payment Success:", response);
         verifyPayment(response)
        // send this response to backend for verification
        // response.razorpay_payment_id
        // response.razorpay_order_id
        // response.razorpay_signature
      },
 
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9999999999",
      },

      theme: {
        color: "#3399cc",
      },
    };

   

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };
  


  return (
     <>
      <style>{css}</style>
      <div className="featured-sales-container">

        {/* Header */}
        <div className="featured-sales-header">
          <div className="featured-sales-header-left">
            <h2>Featured Sales</h2>
            <div className="fs-header-sub">Handpicked premium properties</div>
            <div className="fs-gold-bar" />
          </div>
          <button
            className="featured-filter-btn"
            onClick={() => navigate("/search-results")}
          >
            <span>View All</span>
            <IconArrow />
          </button>
        </div>

        {/* Grid */}
        <div className="featured-sales-grid">
          {properties.map((item) => (
            <div className="featured-card" key={item.id}>

              {/* Image */}
              <div className="featured-image-wrap" onClick={() => navigate('/rental-details/' + item.id)}>
                <img src={Bedroom} alt="property" className="featured-image" />

                {/* Badges */}
                <span className={`fs-badge ${item.status === "rented" ? "fs-badge-rented" : "fs-badge-available"}`}>
                  {item.status === "rented" ? "Rented" : "Available"}
                </span>

                <span className="fs-rating">
                  <IconStar /> 4.8
                </span>

                <span className="fs-type-tag">
                  {item.property_type ? item.property_type.charAt(0).toUpperCase() + item.property_type.slice(1) : "Apartment"}
                </span>
              </div>

              {/* Body */}
              <div className="featured-card-body">

                {/* Name */}
                <h3 className="featured-price" onClick={() => navigate('/rental-details/' + item.id)}>
                  {item?.property_name}
                </h3>

                {/* Rent */}
                <div className="fs-rent-row">
                  <span className="fs-rent-amount">{fmtRent(item?.rent_amount)}</span>
                  <span className="fs-rent-label">/ month</span>
                </div>

                {/* Deposit */}
                <div className="fs-deposit-row">
                  <IconShield />
                  Deposit: <span>{fmtRent(item?.security_deposit)}</span>
                </div>

                <div className="fs-divider" />

                {/* Location */}
                {item?.location && (
                  <p className="featured-location">
                    <IconLocation /> {item.location}
                  </p>
                )}
                {item?.facilities && (
                  <p className="featured-location">
                    <IconLocation /> {item.facilities}
                  </p>
                )}

                {/* Date */}
                <p className="featured-date">
                  <IconCalendar /> Listed {fmtDate(item?.created_at)}
                </p>

                {/* Icon pills */}
                <div className="featured-icons">
                  <span><IconSize />{item?.plot_size ?? "—"} m²</span>
                  <span><IconBed />3+1 Bed</span>
                  <span><IconBath />2 Bath</span>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </>
  );
};

export default FeaturedSales;